// headerBg: "rgba(225, 242, 250, 1)",
const palette = {
  // Legacy colors
  headerBg: "#1D3557",  //457B9D
  footerBg: "#457B9D",  //1D3557
  searchFormBg: "rgba(0, 0, 0, .5)",
  searchButtonBg: "#E63946",
  removeRouteButtonBg: "#ff6663",
  hoverButtonBg: "#D00F1E",
  white: "#fff",

  // Header colors
  header: {
    background: "#ffffff",
    text: "#1a1a2e",
    textMuted: "#64748b",
    textSecondary: "#94a3b8",
    hoverBg: "#f1f5f9",

    // Primary accent (purple)
    primary: "#8b5cf6",
    primaryDark: "#7c3aed",
    primaryLight: "rgba(139, 92, 246, 0.1)",
    primaryShadow: "rgba(139, 92, 246, 0.35)",
    primaryShadowHover: "rgba(139, 92, 246, 0.45)",

    // Status colors
    success: "#10b981",
    danger: "#ef4444",
    dangerDark: "#dc2626",
    dangerBg: "#fef2f2",

    // Border & Shadow
    border: "rgba(0, 0, 0, 0.04)",
    shadow: "rgba(0, 0, 0, 0.06)",

    // Avatar
    avatarGradientStart: "#8b5cf6",
    avatarGradientEnd: "#7c3aed",
    avatarShadow: "rgba(139, 92, 246, 0.3)",
    avatarShadowHover: "rgba(139, 92, 246, 0.4)",

    // Dropdown
    dropdownBg: "#ffffff",
    dropdownBorder: "rgba(0, 0, 0, 0.06)",
    dropdownShadow: "rgba(0, 0, 0, 0.12)",
    dropdownDivider: "#f1f5f9",
    dropdownItemText: "#334155",

    // Mobile menu
    mobileOverlay: "rgba(0, 0, 0, 0.5)",
    mobilePanelShadow: "rgba(0, 0, 0, 0.15)",
  },

  // Button colors (кнопка «Копировать правила» в модалке тарифа)
  button: {
    primary: "#E63946",
    primaryLight: "rgba(230, 57, 70, 0.08)",
  },

  // Status colors
  status: {
    success: "#10b981",
  },

  // Input/Form colors
  input: {
    border: "#ccc",
    borderFocus: "#0052ff",
    borderError: "#e53935",
    borderSuccess: "#8cd64e",
    errorText: "#e53935",
    errorBg: "rgba(229, 57, 53, 0.03)",
    focusShadow: "rgba(0, 82, 255, 0.1)",
    errorShadow: "rgba(229, 57, 53, 0.1)",
    labelText: "#75787b",
  },
};

export default palette;
